import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { useLanguage } from "@/contexts/LanguageContext";

const OfflineBanner = () => {
  const isOnline = useOnlineStatus();
  const { t } = useLanguage();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      className="sticky top-0 z-[9999] flex items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-sm font-medium text-white shadow-sm dark:bg-amber-600"
    >
      <WifiOff size={14} strokeWidth={2.5} />
      <span>
        {t(
          "Jsi offline — některé funkce nemusí být dostupné",
          "Si offline — niektoré funkcie nemusia byť dostupné"
        )}
      </span>
    </div>
  );
};

export default OfflineBanner;
